"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_VISA = void 0;
var NO_VISA = exports.NO_VISA = 'Без визы';